/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PrimaryBillingSource {
    None = '0',
    Location = 1,
    User = 2,
}
